
import { Component, Vue } from "vue-property-decorator";

import { ApplicationModule, getStoreModule, SessionModule } from "@/store";
import { VignetteRoutes } from "@/types";

@Component
export default class TrialBanner extends Vue {
  private sessionStore!: SessionModule;

  private trialProfileLimit = getStoreModule(ApplicationModule, this.$store).getTrialProfileLimit;

  created(): void {
    this.sessionStore = getStoreModule(SessionModule, this.$store);
  }

  get getProfilesRemaining(): string {
    let profilesViewedDuringTrialCount = this.sessionStore.getProfilesViewedDuringTrial.length;
    return profilesViewedDuringTrialCount > this.trialProfileLimit
      ? "0"
      : String(this.trialProfileLimit - profilesViewedDuringTrialCount);
  }

  goToContactUsPage(): void {
    this.$router.push({ name: VignetteRoutes.Contact });
  }
}
